// extracted by mini-css-extract-plugin
export default {"modal":"RefreshModalButton_modal__h4_5o","paper":"RefreshModalButton_paper__1gLrX","heading":"RefreshModalButton_heading__imXpF"};